// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__zstNk","choiceBoxes":"toolbarselects_choiceBoxes__1BimJ","simpleField":"toolbarselects_simpleField__P-g5k"};